/* eslint-disable no-undefined */
import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Route } from 'src/app/_models/view/route';
import { RouteService } from 'src/app/services/route.service';
import { ConversionService } from 'src/app/services/conversion.service';
import { combineLatest, Subscription } from 'rxjs';
import { TripService } from 'src/app/services/trip.service';
import * as DaTrip from '../../../_models/daws/trip';
import { ApplicationSettingsService } from 'src/app/services/application-settings.service';
import { RoutingProfileService } from 'src/app/services/vehicle-routing-profile.service';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';

@Component({
  selector: 'update-route',
  templateUrl: './update-route.component.html',
})
export class UpdateRouteComponent implements OnInit, OnDestroy {
  @Input() route: Route;
  @ViewChild('name') name: ElementRef;
  routeSubscription: Subscription;
  errorMessage = '';
  textMessage: string;
  daRouteOptions: DaTrip.RoutingProfile;
  daRouteStops: DaTrip.StopInfo[];
  systemDefaultProfileId = 0;
  loading = true;
  historicalDataVersion: string;
  defaultProfile: DaTrip.RoutingProfile;
  constructor(
    public updateRouteModalRef: BsModalRef,
    private routeService: RouteService,
    private conversionService: ConversionService,
    private tripService: TripService,
    private applicationSettingsService: ApplicationSettingsService,
    private profileService: RoutingProfileService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.textMessage = `'${this.route.name}' saved route already exists. Would you like to update it?`;
    setTimeout(() => this.name?.nativeElement?.focus());
    this.routeSubscription = combineLatest([
      this.routeService.getMapRoute(this.route.id),
      this.routeService.store$,
      this.routeService.selectedRoute$,
      this.authenticationService.currentUser,
    ]).subscribe(([mapRoute, routeStore, selectedRoute, userInfo]) => {
      const isEuRegion = userInfo?.region?.toUpperCase() === 'EU';
      // Todo-yz: Save route disabled if profile id is -1, for now.
      const tripProfileForRoute = routeStore?.routeList?.filter(
        (pf) => pf.id === this.route.id
      );
      this.route.tripProfileId = tripProfileForRoute?.length
        ? tripProfileForRoute[0].tripProfileId
        : this.systemDefaultProfileId;
      const profiles = this.profileService.getProfiles();
      const profileId = this.route.profileId; // must be greater than zero
      const selectedProfileOptions = profiles.filter(
        (pf) => pf.routingProfileId === profileId
      );
      const profile = this.profileService.getProfile(profileId);
      const selectedProfile = selectedProfileOptions?.length
        ? selectedProfileOptions[0]
        : null;
      mapRoute.options.profileName = selectedProfile?.name;
      //update routeoptions based on selected profile.
      mapRoute.options.vehicleType = this.routeService.getVehicleType(
        selectedProfile?.vehicleType
      );
      mapRoute.options.trkAxles = this.conversionService.getAxels(
        mapRoute?.options?.vehicleType
      );
      mapRoute.options.hazMatType = selectedProfile?.vehicleOptions?.hazmatType
        ? selectedProfile.vehicleOptions.hazmatType
        : 0;
      mapRoute.options.governorSpeedLimit =
        selectedProfile?.vehicleOptions?.governorSpeedLimit;

      if (selectedProfile.routingOptions) {
        mapRoute.options.routeType = selectedProfile?.routingOptions?.routeType;
        mapRoute.options.tollRoads = selectedProfile?.routingOptions?.tollRoads;
        mapRoute.options.ferryDiscourage = selectedProfile?.routingOptions
          ?.ferries
          ? true
          : false;
        mapRoute.options.useTraffic = selectedProfile?.routingOptions
          ?.useTraffic
          ? selectedProfile.routingOptions.useTraffic
          : false;
        mapRoute.options.bordersOpen = selectedProfile?.routingOptions
          ?.useOpenBorders
          ? selectedProfile.routingOptions.useOpenBorders
          : false;
        mapRoute.options.elevLimit =
          selectedProfile?.routingOptions?.elevationLimit;
      }

      this.daRouteOptions = this.conversionService.convertToDARouteOptions(
        mapRoute.options.profileName, // passing selected profileName
        this.route.tripProfileId,
        mapRoute.options,
        profile,
        isEuRegion
          ? selectedRoute?.euProfile
            ? selectedRoute.euProfile
            : undefined
          : undefined
      );

      if (
        this.daRouteOptions?.unitsOfMeasure === 1 &&
        profile?.vehicleOptions?.vehicleConfig
      ) {
        const options = this.conversionService.convertToMetric(
          this.daRouteOptions
        );
        this.daRouteOptions.maxHeight = Number(options?.trkHeight);
        this.daRouteOptions.totalLength = Number(options?.trkLength);
        this.daRouteOptions.maxWidth = Number(options?.trkWidth);
        this.daRouteOptions.totalWeight = Number(options?.trkWeight);
        if (options?.governorSpeedLimit) {
          this.daRouteOptions.governorSpeedLimit = options?.governorSpeedLimit;
        }
        if (options?.elevLimit) {
          this.daRouteOptions.elevationLimit = options?.elevLimit;
        }
      }

      this.daRouteStops = this.conversionService.convertToDALocations(
        this.route.stops
      );
      this.loading = false;

      this.historicalDataVersion = tripProfileForRoute[0].historicalDataVersion;
    });
    this.applicationSettingsService.store$.subscribe((appSettings) => {
      if (appSettings) {
        this.defaultProfile = appSettings;
        this.systemDefaultProfileId = appSettings.routingProfileId;
      }
    });
  }

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
  }
  keydownEvent(event) {
    if (event.key === 'Enter') {
      this.updateRoute();
    }
  }
  updateRoute() {
    this.loading = true;
    this.daRouteOptions.dataVersion = this.historicalDataVersion;
    const trip: DaTrip.Trip = {
      Name: this.route.name,
      Profile: this.daRouteOptions,
      Stops: this.daRouteStops,
      Id: this.route.savedId,
      ModifiedOn: null,
    };
    delete trip.ModifiedOn;
    this.tripService.updateTrip(trip).subscribe(
      (result) => {
        this.updateRouteModalRef.hide();
        this.loading = false;
        this.routeService.updateRouteAfterUpdate(this.route.id);
      },
      (err) => {
        this.errorMessage = 'There was an error replacing the saved route.';
        this.loading = false;
      }
    );
  }
}
